import Vue from 'vue'
import VueRouter from 'vue-router'

// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import store from '@/store/index'

import util from '@/libs/util.js'

import * as ddEnv from 'dingtalk-jsapi/lib/env'

// 路由数据
import routes from './routes'
import { toOauth, passwordFreeLogin } from '@/api'

Vue.use(VueRouter)

// 注册路由 并由export导出 在 main.js 里使用
const router = new VueRouter({
  routes
})

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
  // 进度条
  NProgress.start()
  // 关闭搜索面板
  store.commit('d2admin/search/set', false)

  if (['ios', 'android'].includes(ddEnv.getENV().platform)) {
    // 钉钉移动端判断
    if (to.name === 'login') {
      if (to.query.redirect) {
        toOauth(to.query.redirect)
      }
    }
  
    if (to.name == 'redirect') {
      const { openId, unionid, nick } = to.query
      const res = await passwordFreeLogin({ openId, loginType: 102, unionid, nickName: nick })
      if (res.success) {
        util.cookies.remove('token')
        util.cookies.set('token', res.data.token)
        next(to.query.routerUrl)
      } else {
        next('/login')
      }
    }
  }

  // 判断是否有页面权限
  if (to.meta && to.meta.needCheckAuth != false) {
    var _menuList = sessionStorage.getItem('menuStr')
    if (_menuList && _menuList.indexOf(to.path) == -1) {
      next({
        name: 'noEnter'
      })
    }
  }
  // 验证当前路由所有的匹配中是否需要有登录验证的
  if (to.matched.some(r => r.meta.auth)) {
    // 这里暂时将cookie里是否存有token作为验证是否登录的条件
    // 请根据自身业务需要修改
    const token = util.cookies.get('token')
    if (token && token !== 'undefined') {
      next()
    } else {
      // 没有登录的时候跳转到登录界面
      // 携带上登陆成功之后需要跳转的页面完整路径
      next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      })
      NProgress.done()
    }
  } else {
    // 不需要身份校验 直接通过
    next()
  }
})
const sysNames = {
  mall: '商城系统',
  erp: 'ERP系统',
  coupon: '优惠券系统',
  contract: '合同管理系统',
  risk: '风控系统',
  product: '商品管理系统',
  workflow: '工作流系统',
  self: '统一登入鉴权系统'
}
router.afterEach(to => {
  // 进度条
  NProgress.done()
  // 多页控制 打开新的页面
  store.dispatch('d2admin/page/open', to)
  if (to.path === '/login') {
    const parmas = to.query.ru || ''
    if (parmas.includes('man')) {
      util.title(sysNames['mall'])
    } else if (parmas.includes('erp')) {
      util.title(sysNames['erp'])
    } else if (parmas.includes('coupon')) {
      util.title(sysNames['coupon'])
    } else if (parmas.includes('contract')) {
      util.title(sysNames['contract'])
    } else if (parmas.includes('risk')) {
      util.title(sysNames['risk'])
    } else if (parmas.includes('product')) {
      util.title(sysNames['product'])
    } else if (parmas.includes('workflow')) {
      util.title(sysNames['workflow'])
    } else {
      util.title(sysNames['self'])
    }
  } else {
    util.title(to.meta.title)
  }
})

export default router
